import script from "./WizardBlindDeviceRegistStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardBlindDeviceRegistStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardBlindDeviceRegistStep.vue?vue&type=style&index=0&id=1a6b0b75&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6b0b75"]])

export default __exports__